import { APIClient } from "@frontend/api-utils";
import { EquipmentStateName } from "@frontend/equipment/types";

export class StockEquipmentClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async fetchSpotEquipmentStates(accountId: string, spotId: string): Promise<EquipmentStateName[]> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/equipment-states`);
        return await this.handleResponse<EquipmentStateName[]>(response);
    }
}
